// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM11.6582 5L8.99707 7.06445L10.2236 8.64453L11.4004 7.73047V19H13.4004V5H11.6582Z"}}]};

const NumbersCircle1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-circle-1-filled',
    ref,
    icon: element,
  },
));

NumbersCircle1FilledIcon.displayName = 'NumbersCircle1FilledIcon';

export default NumbersCircle1FilledIcon;
